import React, { useState, useEffect } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import QRCode from 'qrcode.react';
import './QRModal.scss';

// You would typically install this with: npm install qrcode.react
// For this environment, we assume it's available.

interface QRModalProps {
  show: boolean;
  onHide: () => void;
  receiptId: number | null;
}

const QRModal: React.FC<QRModalProps> = ({ show, onHide, receiptId }) => {
  const [qrValue, setQrValue] = useState<string | null>(null);

  useEffect(() => {
    if (show && receiptId) {
      // Construct the URL to be encoded
      const url = `${window.location.origin}/ClientReviews/${receiptId}`;
      setQrValue(url);
    } else {
      // Reset when hidden or if no receiptId to show loading spinner on next open
      setQrValue(null);
    }
  }, [show, receiptId]);

  return (
    <Modal show={show} onHide={onHide} centered dialogClassName="qr-modal">
      <Modal.Header>
        <Modal.Title>QR para Recibo #{receiptId}</Modal.Title>
        <Button variant="none" className="modal-close-button" onClick={onHide}>
          <X size={24} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        {qrValue ? (
          <>
            <div className="qr-code-wrapper">
              <QRCode
                value={qrValue}
                size={256} // QR Code size
                bgColor={"#ffffff"}
                fgColor={"#000000"}
                level={"L"} // Error correction level
                includeMargin={false}
                renderAs={"svg"}
              />
            </div>
            <p className="scan-prompt">Escanee este código para ver la boleta.</p>
            <p className="url-text">{qrValue}</p>
          </>
        ) : (
          <div className="loading-container">
            <Spinner animation="border" role="status" />
            <p className="mt-2">Generando QR...</p>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="none" className='form-button-cancel' onClick={onHide}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default QRModal;
